import { NgModule } from '@angular/core';
import { AswCommonStoreService } from './asw-common-store.service';

@NgModule({
  providers: [AswCommonStoreService],
})
export class AswCommonStoreServiceModule {}
